import script from "./FormatComparisonSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FormatComparisonSection.vue?vue&type=script&setup=true&lang=js"

import "./FormatComparisonSection.vue?vue&type=style&index=0&id=e9d6dbee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9d6dbee"]])

export default __exports__